// extracted by mini-css-extract-plugin
module.exports = {"Legal":"Legal_Legal__2Vu6R","LegalLinks":"Legal_LegalLinks__2DrrZ"};